import { useEffect, useRef, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Button, useColorMode } from 'theme-ui';
import dropdownIcon from "../assets/images/Icon/dropdownicon.svg";
import dot from "../assets/images/Icon/dot.svg";
import queryString from 'query-string';
import { FaCheckSquare, FaGripLinesVertical, FaRegCheckCircle } from 'react-icons/fa';

// new

interface DropDownURLProps {
    customDropdownProps?: any;
    name?: string;
    url?: string
}

export const DropDownURL = ({ customDropdownProps }: DropDownURLProps) => {
    const location = useLocation();
    const currentUrl = window.location.pathname.split('/')[1];
    const { isPopoverOpen, togglePopover, setIsPopoverOpen, urlArray } = customDropdownProps
    const [selectedValue, setSelectedValue] = useState(localStorage.getItem(currentUrl) || "Default");
    const popoverRef = useRef<HTMLDivElement>(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const parsedQuery = queryString.parse(location.search);

    const addQueryStr = (str: string, dropValue: string) => {
        const { isMEP, isStructural, isFireSprinkler } = parsedQuery;
        if (dropValue === "Default") {
            const nextParams: any = {};
            if (isMEP) nextParams.isMEP = isMEP;
            if (isStructural) nextParams.isStructural = isStructural;
            if (isFireSprinkler) nextParams.isFireSprinkler = isFireSprinkler;
            setSearchParams(nextParams);
        } else {
            const parsedQuerys = queryString.parse(str) as any;
            const { status, ...restparsedQuery } = parsedQuery;
            let newUrl: any = {};
            if (parsedQuerys.status) {
                newUrl = { ...parsedQuerys, ...restparsedQuery, status: parsedQuerys?.status, stat: "" }
            } else {
                newUrl = { ...parsedQuerys, ...restparsedQuery, stat: parsedQuerys?.stat, sortField: parsedQuerys?.sortField }
            }

            if (isMEP) newUrl.isMEP = isMEP;
            if (isStructural) newUrl.isStructural = isStructural;
            if (isFireSprinkler) newUrl.isFireSprinkler = isFireSprinkler;

            const queryStrings = Object.keys(newUrl)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(`${newUrl[key]}`)}`)
                .join('&');
            setSearchParams(queryStrings)
        }
        setSelectedValue(dropValue);
        localStorage.setItem(currentUrl.toString(), dropValue.toString());
        setIsPopoverOpen(false);
    }


    const handleClickOutside = (event: any) => {
        if (!event.target.closest('.popover-content')) {

            if (!event.target.closest('.toggle-btn')) {
                setIsPopoverOpen(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const { stat, status: queryStatus } = parsedQuery;
        let value = "Default";

        if (stat === "CustomOrder1") value = "CustomOrder1";
        else if (stat === "CustomOrder2") value = "CustomOrder2";
        else if (queryStatus === "Delivered" || queryStatus === "IPR Delivered") value = "Delivered";
        else if (queryStatus === "Ready To Deliver" || queryStatus === "IPR Ready To Deliver") value = "Ready To Deliver";
        else if (queryStatus === "Draft") value = "Draft";
        else if (queryStatus === "On Hold" || queryStatus === "OnHold") value = "On Hold";

        setSelectedValue(value);
        localStorage.setItem(currentUrl.toString(), value);
    }, [location.search])
    const [colorMode] = useColorMode();
    return (
        <>
            {/* <div ref={popoverRef} className='d-flex g-4 position-relative ' > */}
            <Button variant='PrimaryHeadBtn' onClick={togglePopover} className='toggle-btn' sx={{ marginLeft: "60px" }}>
                {selectedValue}
                <img src={dropdownIcon} style={{ marginLeft: "10px" }} />
            </Button>
            {isPopoverOpen && (
                <div className="popover-content" style={{ position: 'fixed', zIndex: 99999999, backgroundColor: colorMode === "light" ? "#fff" : "#20283c" }}>
                    <ul className="headermenu" onClick={togglePopover} >
                        {urlArray.map((element: DropDownURLProps, index: number) => {
                            let { name, url } = element
                            return (
                                <li key={index} className={`${selectedValue === name ? "active-dropdown" : ""}`}>
                                    <p onClick={() => addQueryStr(url || "", name || "")} className="DashboardSide custom-des-a" style={{ color: name === 'Ready To Deliver' ? '#ffc21a' : name === 'Delivered' ? '#0ddf0d' : name === 'On Hold' ? '#1153e2' : colorMode === "light" ? "#020202" : "#fff" }} >
                                        {name === 'Ready To Deliver' ? <FaRegCheckCircle className='mt-2' style={{ color: '#ffc21a' }} /> : name === 'Delivered' ? <FaCheckSquare className='mt-2' style={{ color: '#0ddf0d' }} /> : name === 'On Hold' ? <FaGripLinesVertical className='mt-2' style={{ color: '#1153e2' }} /> : <img className='mt-2' src={dot} />}
                                        {name}
                                    </p>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            )}
            {/* </div> */}

        </>
    );
};
